import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { deleteOpportunity, updateOpportunity } from "../graphQL/graphMutation";

export const updateOpportuniService = async (values, id) => {

  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateOpportunity, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateOpportunityService-error");
    errormessage=err.response.errors?.[0].message;
    updateStatus = false;
  }
  return {updateStatus,errormessage};
};

export const deleteOpportunityService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, deleteOpportunity, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteOpportunitytypeService error");
    delteStatus = false;
  }

  return delteStatus;
};
